import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { LoginView } from '../../Views/Login/Login.View';
import { InviteView } from '../../Views/Login/Invites/InviteView';
import { LoginLayout } from '../../Views/Login/Layout/Login.Layout';
import { SignUpView } from '../../Views/Login/SignUp/SignUp.View';
import { SelectOrg } from '../../Views/Login/SelectOrg/SelectOrg';
import { AccountInterface } from '@swivl-mono/types';
import AccountModel from '../../Models/Account/AccountModel';
import { ForgotPasswordView } from '../../Views/Login/Forgot/ForgotPassword.View';
import { ResetPasswordView } from '../../Views/Login/Reset/ResetPassword.View';
import TranscriptView from '../../Views/ContactCenter/Conversations/Transcript/TranscriptView';
import TicketAccessView from '../../Views/TicketAccess/TicketAccessView';
import TranscriptAccessView from '../../Views/TranscriptAccess/TranscriptAccessView';
import { useEffect } from 'react';
import { LoadingView } from '../Layout/Loading/LoadingView';



interface Props {
  account?: AccountInterface;
}

export default function RouterLoggedOut(props: Props) {
  const { invites } = AccountModel.useState(s => s);

  useEffect(() => {
    if (props.account) {
      AccountModel.loadInvitesForAccount(props.account.id);
    }
  }, [props.account]);
  if (props.account) {

    // Only block on the initial fetch — a null from the login API means
    // "no invites", not "still loading" (ENG-2836).
    if (invites === undefined) {

      return <LoadingView />;
    }
    if (invites && invites.length > 0) {
      return (
        <Routes>
          <Route path="transcript/:userId" element={<TranscriptView />} />
          <Route path="ticket-access/:token" element={<TicketAccessView />} />
          <Route path="conversations/access/:token" element={<TranscriptAccessView />} />
          <Route path="/" element={<LoginLayout />}>
            <Route path="/invites" element={<InviteView />} />
            <Route path="/invite/:inviteUUID" element={<InviteView />} />
            <Route path="/select-org" element={<SelectOrg />} />
            <Route path="*" element={<Navigate to={'/invites'} />} />
          </Route>
          <Route path="*" element={<Navigate to={'/invites'} />} />
        </Routes>
      );
    }

    return (
      <Routes>
        <Route path="/invites" element={<InviteView />} />

        <Route path="transcript/:userId" element={<TranscriptView />} />
        <Route path="ticket-access/:token" element={<TicketAccessView />} />
        <Route path="conversations/access/:token" element={<TranscriptAccessView />} />
        <Route path="/select-org" element={<LoginLayout />}>
          <Route path="/select-org" element={<SelectOrg />} />
        </Route>
        <Route path="*" element={<Navigate to={'/select-org'} replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="transcript/:userId" element={<TranscriptView />} />
      <Route path="ticket-access/:token" element={<TicketAccessView />} />
      <Route path="conversations/access/:token" element={<TranscriptAccessView />} />
      <Route path="/" element={<LoginLayout />}>
        <Route path="/invite/:inviteUUID" element={<InviteView />} />
        <Route path="/login" element={<LoginView />} />
        <Route path="/forgot-password" element={<ForgotPasswordView />} />
        <Route path="/sign-up" element={<SignUpView />} />
        <Route path="/reset-password/:token" element={<ResetPasswordView />} />
        <Route path="/" element={<Navigate to={'/login'} replace />} />
      </Route>
      <Route path="*" element={<Navigate to={"/login"} replace />} />
    </Routes>
  );
}
